import { api } from "@/services/api"
import { useQuery } from "@tanstack/vue-query"
import type { MaybeRef } from "vue"
import type { User } from "./sharedTypes"

export type ListUsersFilter = {
  search?: string
}

export type ListUsersOrdering = "name" | "-name"

export type ListUsersQuery = ListUsersFilter & {
  ordering?: ListUsersOrdering
} & Pagination

const listUsers = async (
  query?: ListUsersQuery
): Promise<Paginate<User[]>> => {
  const { body } = await api.get<
    RecursivelyConvertDatesToStrings<Paginate<User[]>>
  >("/users/", { query })

  return body
}

export const useUsers = (
  query?: MaybeRef<ListUsersQuery>
) =>
  useQuery({
    queryKey: [USERS_QUERY_KEY, query] as const,
    queryFn: ({ queryKey: [_, query_] }) =>
      listUsers(query_),
  })
